import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginRequest } from '../../models/login/login-request.model';
import { ForgotPassword } from '../../models/forgotpassword/forgot-password.model';
import { ResetPassword } from '../../models/resetpassword/reset-password.model';
import { environment } from '../../../environments/environment';
import * as commonFunction from '../../services/common.function';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  constructor(private http: HttpClient) {
  }

  handleError(error: any) {
    let Message = 'Unknown error!';
    if (error.status == 400) {
      if (!!error.error.Email) { // false
        Message = `Error: ${error.error.Email}`;
        return throwError(Message);
      }
      else if (!!error.error.IPAddress) { // false
        Message = `Error: ${error.error.IPAddress}`;
        return throwError(Message);
      }
    }
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      Message = `Error: ${error.error.errorMessage}`;
    } else {
      // Server-side errors
      Message = `${error.error.errorMessage}`;
    }
    return throwError(Message);
  }

  loginUser(requestLogin: any) {
    const body: LoginRequest = {
      Email: requestLogin.Email,
      Password: requestLogin.Password,
      ipAddress: requestLogin.IpAddress,
      TimeZone: commonFunction.GetTimeZone(),
    }

    return this.http.post(`${environment.WebApiURL}api/Authentication/Login`, body, { headers: { 'IgnoreInterceptor': '' } }).pipe(
      catchError(this.handleError), map((response: any) => {
        userInfo.data = response;
        return response;
      }));
  }

  checkEmailIsExist(stEmail:any){
    return this.http.get(environment.WebApiURL + 'api/Authentication/CheckEmailIsExist?stEmail=' + stEmail, { headers: { 'IgnoreInterceptor': '' } }).pipe(map((response: any) => {
      return response;
    }));
  }

  getUserLoginHistory(data: any) {

    const body = {
      TimeZone: data.TimeZone,
      userId: data.userId,
      fromDate: data.fromDate,
      toDate: data.toDate,
      stSortColumn: data.stSortColumn,
      stSortOrder: data.stSortOrder,
      inOffset: data.inOffset,
      inLimit: data.inLimit,
      stSearchText: data.stSearchText
    }

    return this.http.post(`${environment.WebApiURL}api/Authentication/GetUserLoginHistory`, body).pipe(map((response: any) => {
      return response
    }));
  }

  loginWith(userId: any, ipAddresss: any, isManageLoginHistory: any, userIds: any) {
    const body = {
      uiUserId: userId,
      ipAddress: ipAddresss,
     // TimeZone: commonFunction.GetTimeZone(),
      isManageLoginHistory: isManageLoginHistory,
      userIds: userIds
    }
    return this.http.post(`${environment.WebApiURL}api/Authentication/LoginWith`, body).pipe(map((response: any) => {
      return response
    }));
  }

  logout() {
    // const body = {
    //   accessToken: accessToken,
    //   flgIsActive: flgIsActive
    // }
    return this.http.get(`${environment.WebApiURL}api/Authentication/logout`).pipe(map((response: any) => {
      return response
    }));
  }

  /**
   * Logout call that explicitly sends a Bearer token.
   * Useful when localStorage is already cleared (e.g., Verisk SSO logout flow).
   */
  logoutWithAccessToken(accessToken: string) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`,
      'IgnoreInterceptor': '' // prevent AuthInterceptor from overriding headers
    });
    return this.http.get(`${environment.WebApiURL}api/Authentication/logout`, { headers }).pipe(
      map((response: any) => response)
    );
  }

  // Security hotfix HF-01.2 (FE-1): externalIdToken is the Google or Microsoft ID token from the sign-in result,
  // sent only on this request in X-External-Id-Token
  externalloginWith(userId: any, ipAddresss: any, isManageLoginHistory: any, externalIdToken: string) {
    const body = {
      uiUserId: userId,
      ipAddress: ipAddresss,
     // TimeZone: commonFunction.GetTimeZone(),
      isManageLoginHistory: isManageLoginHistory
    }

    return this.http.post(`${environment.WebApiURL}api/Authentication/LoginWithExternalAsync`, body, { headers: { 'IgnoreInterceptor': '', 'X-External-Id-Token': externalIdToken || '' } }).pipe(
      catchError(this.handleError), map((response: any) => {
        userInfo.data = response;
        return response;
      })); 
  }

  forgotPassword(requestForgotPassword: any) {
    const body: ForgotPassword = {
      Email: requestForgotPassword.Email
    }
    return this.http.post(environment.WebApiURL + 'api/Authentication/ForgotPassword', body, { headers: { 'IgnoreInterceptor': '' } });
  }

  resetPassword(requestForgotPassword: any) {
    const body: ResetPassword = {
      ResetPasswordToken: requestForgotPassword.ResetPasswordToken,
      NewPassword: requestForgotPassword.NewPassword,
      ConfirmNewPassword: requestForgotPassword.ConfirmNewPassword
    }
    return this.http.post(environment.WebApiURL + 'api/Authentication/ResetPassword', body, { headers: { 'IgnoreInterceptor': '' } });
  }

  /**
   * Validates Verisk SSO token and returns user data
   * @param token - The encrypted JWT token in format: encryptedToken~encryptionKey
   * @param ipAddress - User's IP address
   */
  validateSSOToken(token: string, ipAddress: string) {
    const body = {
      token: token,
      ipAddress: ipAddress || ':1:',
      TimeZone: commonFunction.GetTimeZone()
    }
    return this.http.post(`${environment.WebApiURL}api/Authentication/ValidateSSOToken`, body, { headers: { 'IgnoreInterceptor': '' } }).pipe(
      catchError(this.handleError), map((response: any) => {
        if (response && response.data) {
          userInfo.data = response;
        }
        return response;
      }));
  }
}

export const userInfo: any = {
  data: ''
};
